import React from 'react';
import { motion } from 'framer-motion';
export function ServicesGrid() {
  const services = [{
    id: '01',
    icon: '🐜',
    title: 'Ant Control',
    desc: 'Complete colony elimination with targeted baiting systems and perimeter defense.'
  }, {
    id: '02',
    icon: '🕷️',
    title: 'Spider Treatment',
    desc: 'Web removal and barrier treatments to keep spiders out of your living spaces.'
  }, {
    id: '03',
    icon: '🐀',
    title: 'Rodent Exclusion',
    desc: 'Seal entry points and remove rodents with humane, effective methods.'
  }, {
    id: '04',
    icon: '🦟',
    title: 'Mosquito Defense',
    desc: 'Yard treatments and breeding site elimination for mosquito-free outdoor living.'
  }, {
    id: '05',
    icon: '',
    title: 'Roach Elimination',
    desc: 'Deep treatment programs that eliminate roaches at every life stage.',
    customIcon: true
  }, {
    id: '06',
    icon: '🐝',
    title: 'Wasp & Bee Removal',
    desc: 'Safe nest removal and prevention to protect your family and pets.'
  }];
  return <section id="services" className="bg-brand-black py-24 px-6" data-id="element-245">
      <div className="max-w-7xl mx-auto" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-247">
          <div className="flex items-center gap-4 mb-4" data-id="element-248">
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-249" />
            <span className="font-condensed uppercase text-brand-green tracking-widest font-semibold" data-id="element-250">
              Services
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl text-white" data-id="element-251">
            WHAT WE <span className="text-brand-green" data-id="element-252">ELIMINATE</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[2px] bg-white/5" data-id="element-253">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative bg-brand-card p-6 md:p-10 overflow-hidden transition-transform duration-300 hover:-translate-y-1.5 cursor-pointer" data-id="element-254">
              {/* Top Border Hover Effect */}
              <div className="absolute top-0 left-0 w-full h-[3px] bg-brand-green origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out" data-id="element-255" />

              {/* Ghost Number */}
              <div className="absolute top-4 right-4 text-8xl font-bebas text-white opacity-[0.03] leading-none pointer-events-none" data-id="element-256">
                {service.id}
              </div>

              <div className="relative z-10 flex flex-col h-full" data-id="element-257">
                <div className="text-4xl md:text-5xl mb-4 md:mb-6" data-id="element-258">
                  {(service as any).customIcon ? <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-259">
                      {/* Body */}
                      <ellipse cx="32" cy="36" rx="12" ry="16" fill="#8B4513" data-id="element-260" />
                      <ellipse cx="32" cy="36" rx="10" ry="14" fill="#A0522D" data-id="element-261" />
                      {/* Head */}
                      <ellipse cx="32" cy="18" rx="8" ry="7" fill="#8B4513" data-id="element-262" />
                      <ellipse cx="32" cy="18" rx="6.5" ry="5.5" fill="#A0522D" data-id="element-263" />
                      {/* Eyes */}
                      <circle cx="28" cy="16" r="2.5" fill="white" data-id="element-264" />
                      <circle cx="36" cy="16" r="2.5" fill="white" data-id="element-265" />
                      <circle cx="29" cy="15.5" r="1.2" fill="black" data-id="element-266" />
                      <circle cx="37" cy="15.5" r="1.2" fill="black" data-id="element-267" />
                      {/* Antennae */}
                      <path d="M28 12 Q22 4 18 2" stroke="#8B4513" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-268" />
                      <path d="M36 12 Q42 4 46 2" stroke="#8B4513" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-269" />
                      <circle cx="18" cy="2" r="2" fill="#8B4513" data-id="element-270" />
                      <circle cx="46" cy="2" r="2" fill="#8B4513" data-id="element-271" />
                      {/* Legs - left */}
                      <path d="M22 28 Q14 24 8 22" stroke="#8B4513" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-272" />
                      <path d="M21 36 Q12 36 6 34" stroke="#8B4513" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-273" />
                      <path d="M22 44 Q14 48 8 52" stroke="#8B4513" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-274" />
                      {/* Legs - right */}
                      <path d="M42 28 Q50 24 56 22" stroke="#8B4513" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-275" />
                      <path d="M43 36 Q52 36 58 34" stroke="#8B4513" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-276" />
                      <path d="M42 44 Q50 48 56 52" stroke="#8B4513" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-277" />
                      {/* Wing line */}
                      <line x1="32" y1="24" x2="32" y2="48" stroke="#6B3410" strokeWidth="1" opacity="0.5" data-id="element-278" />
                    </svg> : service.icon}
                </div>
                <h3 className="font-condensed uppercase text-xl md:text-2xl font-semibold text-white mb-2 md:mb-3 tracking-wide" data-id="element-279">
                  {service.title}
                </h3>
                <p className="font-barlow text-brand-gray text-sm md:text-base leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-280">
                  {service.desc}
                </p>

                <div className="font-condensed uppercase text-brand-green font-semibold tracking-wider opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 flex items-center gap-2" data-id="element-281">
                  Learn More <span data-id="element-282">→</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}